import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = { class: "signup" }
const _hoisted_2 = { class: "loading" }
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "p__style__4" }
const _hoisted_5 = { class: "p__style__4" }
const _hoisted_6 = { class: "p__style__4" }
const _hoisted_7 = { class: "p__style__4" }
const _hoisted_8 = { class: "button-area" }

import { onMounted, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountDetail',
  setup(__props) {

const isUser = ref(false);
const router = useRouter();

const userInfoStore = UserInfoStore();
const loading = ref(false);
onMounted(() => {
  if (userInfoStore.userDetail.id) {
    isUser.value = true;
    document.title = "プロフィール情報";
  }
});

function push() {
  router.push("/sign-up");
}

function displayBirthDay() {
  return (
    userInfoStore.userDetail.birthday.substring(0, 4) +
    "年" +
    userInfoStore.userDetail.birthday.substring(5, 7) +
    "月" +
    userInfoStore.userDetail.birthday.substring(8, 10) +
    "日"
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _cache[1] || (_cache[1] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
    ]), 512 /* NEED_PATCH */), [
      [_vShow, loading.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "detail-title" }, "ニックネーム", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(userInfoStore).userDetail.name), 1 /* TEXT */),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "detail-title" }, "名前", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(userInfoStore).userDetail.last_name) + " " + _toDisplayString(_unref(userInfoStore).userDetail.first_name), 1 /* TEXT */),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "detail-title" }, "生年月日", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_6, _toDisplayString(displayBirthDay()), 1 /* TEXT */),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "detail-title" }, "メールアドレス", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(userInfoStore).userDetail.email), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(CommonButton, {
        data: {
          status: 0,
          button: `編集`,
        },
        style: {"max-width":"317px"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (push()))
      })
    ])
  ]))
}
}

})